export default __webpack_public_path__ + "static/media/CIA-Objection-Request-POPI-Form.40cec915.pdf";